import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useBaseFormSlot } from "../../../../slots/forms/slots/forms/form-context.js";
const FormFieldsWithCart = ({ formName }) => {
  const { Slots } = useBaseFormSlot();
  const FormFieldsComponent = React.useMemo(() => Slots[formName], [Slots, formName]);
  const { cart } = Context.useCart();
  const cartConfig = React.useMemo(
    () => ({
      cartContainsContactLenses: cart?.contains.contactLenses,
      cartContainsSolutions: cart?.contains.solutions,
      cartContainsPrescriptionGlasses: cart?.contains.prescriptionGlasses,
      cartContainsSunglasses: cart?.contains.sunglasses,
      cartContainsSubscription: cart?.contains.subscription
    }),
    [cart]
  );
  if (!FormFieldsComponent) return null;
  return /* @__PURE__ */ React.createElement(
    FormFieldsComponent,
    {
      cartContainsContactLenses: cartConfig.cartContainsContactLenses,
      cartContainsSolutions: cartConfig.cartContainsSolutions,
      cartContainsSunglasses: cartConfig.cartContainsSunglasses,
      cartContainsSubscription: cartConfig.cartContainsSubscription,
      cartContainsPrescriptionGlasses: cartConfig.cartContainsPrescriptionGlasses
    }
  );
};
export {
  FormFieldsWithCart
};
//# sourceMappingURL=FormFieldsWithCart.js.map
